import { Injectable, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../constants/constants';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Messages } from '../messages/messages';
import { HeaderAlertModalComponent } from 'src/app/shared/components/header-alert-modal/header-alert-modal.component';
import { NgxPubSubService } from '@pscoped/ngx-pub-sub';

declare var MiniProfiler: any;
@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  constructor(private eventService: NgxPubSubService, private ngZone: NgZone, private dialogService: DialogService) {
  }
  errorDialogRef: any;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = JSON.parse(sessionStorage[Constants.AccessToken]);
    if (accessToken) {
      // merge the bearer token into the existing headers
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken.accessToken,
        }
      });
    }
    return next.handle(request).pipe(tap(
      (response: HttpEvent<any>) => {
        if (response instanceof HttpResponse) {
          if (response && response.headers) {
            this.makeMiniProfilerRequests(response.headers);
          }
        }
      },
      (error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.status === 401) {
          this.eventService.publishEvent(Constants.UnauthorizedAccessEvent, true);
        } else {
          this.showHttpErrorDialog(error);
        }
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
      }
    ));
  }

  /**
   * Desc: Function to show dialog for http errors.
   */
  showHttpErrorDialog(error) {
    this.ngZone.run(() => {
      if (!this.errorDialogRef) {
        this.errorDialogRef = this.dialogService.open({
          content: HeaderAlertModalComponent,
        });
        const userInfo = this.errorDialogRef.content.instance;
        userInfo.message = Messages.Dialog_Message_Error;
        if (error.error && error.error.message) {
          userInfo.message = error.error.message;
        }
        this.errorDialogRef.result
          .subscribe(resp => {
            this.errorDialogRef = null;  // clear old reference
          });
      }
    });
  }

  /**
   * Descp:Function to make miniProfiler Requests
   * @param headers:http headers
   */
  private makeMiniProfilerRequests(headers: HttpHeaders) {
    const miniProfilerHeaders = headers.getAll('x-miniprofiler-ids');
    if (!miniProfilerHeaders) {
      return;
    }
    miniProfilerHeaders.forEach(miniProfilerIdHeaderValue => {
      const ids = JSON.parse(miniProfilerIdHeaderValue) as string[];
      if (typeof MiniProfiler !== 'undefined' && MiniProfiler) {
        MiniProfiler.fetchResults(ids);
      }
    });
  }
}
